export interface UserProfile {
  id: string;
  email: string;
  alias: string;
  role: string;
  roles?: string[];
  permissions?: string[];
  event?: string | null; // WhatsApp-Nummer
  info?: string | null;  // Last Activity Timestamp
  active?: boolean;
  weekly_goal_notify_enabled?: boolean;
  team_id?: number | null;
  team_name?: string | null;
  profile_image?: string | null;
  // Quiz-Felder (Server liefert teils Strings/Ints) – wir erlauben beides
  quiz_1_1?: number | string; quiz_1_2?: number | string; quiz_1_3?: number | string; quiz_1_4?: number | string; quiz_1_5?: number | string;
  quiz_2_1?: number | string; quiz_2_2?: number | string; quiz_2_3?: number | string; quiz_2_4?: number | string; quiz_2_5?: number | string;
  quiz_3_1?: number | string; quiz_3_2?: number | string; quiz_3_3?: number | string; quiz_3_4?: number | string; quiz_3_5?: number | string;
  quiz_4_1?: number | string; quiz_4_2?: number | string; quiz_4_3?: number | string; quiz_4_4?: number | string; quiz_4_5?: number | string;
  quiz_5_1?: number | string; quiz_5_2?: number | string; quiz_5_3?: number | string; quiz_5_4?: number | string; quiz_5_5?: number | string; quiz_5_99?: number | string;
  quiz_6_1?: number | string; quiz_6_2?: number | string; quiz_6_3?: number | string; quiz_6_4?: number | string; quiz_6_5?: number | string; quiz_6_6?: number | string; quiz_6_7?: number | string;
}

export const parseScore = (v: number | string | undefined): number => {
  if (v === undefined || v === null) return 0;
  const n = typeof v === 'string' ? parseInt(v, 10) : v;
  return Number.isFinite(n as number) ? (n as number) : 0;
};
